import Api from '@/modules/core/api/api.ts';
import { RegionAdapter } from '@/modules/counterparty/adapters/region.adapter.ts';
import { RegionEndPoint } from '@/modules/counterparty/enums/counterparty-end-point.enum.ts';
import { RequestUtil } from '@/modules/core/utils/request.util.ts';
import { Direction } from '@/modules/common/enums/direction.enum.ts';
import type { RegionDto } from '@/modules/counterparty/dto/region.dto.ts';
import type { ItemsDto } from '@/modules/common/dto/items.dto.ts';
import { requirePositiveId } from '@/modules/common/utils/number.util.ts';

export class RegionApi {
  static async getList(signal: AbortSignal) {
    const response: ItemsDto<RegionDto> = await Api.post(
      RegionEndPoint.GetList,
      RequestUtil.orderBy('Название', Direction.Asc),
      signal
    );
    return RegionAdapter.mapList(response);
  }

  static async add(name: string, tzId: number, center?: string, note?: string, signal?: AbortSignal) {
    const response = await Api.post(
      RegionEndPoint.Add,
      {
        region_name: name,
        tz_id: tzId,
        region_center: center || undefined,
        note: note || undefined,
      },
      signal
    );
    return requirePositiveId(response.region_id, 'The region id is not defined.');
  }

  static async edit(id: number, name: string, tzId: number, center = '', note = '', signal?: AbortSignal) {
    const response = await Api.post(
      RegionEndPoint.Edit,
      {
        region_id: id,
        region_name: name,
        tz_id: tzId,
        region_center: center,
        note,
      },
      signal
    );
    return requirePositiveId(response.region_id, 'The region id is not defined.');
  }

  static async delete(id: number, signal?: AbortSignal) {
    await Api.post(RegionEndPoint.Delete, { region_id: id }, signal);
  }
}
